import React from "react";
import {withNamespaces} from "react-i18next";

import PageSeo from "../../seo/PageSeo";
import {
    ContactsMapSection,
} from "./ContactsMapSection";
import "./style.less";

const PUBLIC_SITE_URL = "https://svetofore.ru";

const COMPANY_FULL_NAME =
    "ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ «СВЕТОФОР ЛОГИСТИКА»";

const COMPANY_SHORT_NAME =
    "ООО «СВЕТОФОР ЛОГИСТИКА»";

const ACTUAL_ADDRESS =
    "660020, Красноярский Край, г. Красноярск, ул. Взлетная, д. 59";

const LEGAL_ADDRESS =
    "660031, Красноярский край, г. Красноярск, ул. Айвазовского, д. 57, помещ. 10";

const requisites = Object.freeze([
    {
        labelKey:
            "main.contactsPage.requisites.okved",
        value:
            "62.01 - Разработка компьютерного программного обеспечения",
    },
    {
        labelKey:
            "main.contactsPage.requisites.itActivity",
        value: "1.01",
    },
    {
        labelKey:
            "main.contactsPage.requisites.inn",
        value: "2462225394",
    },
    {
        labelKey:
            "main.contactsPage.requisites.ogrn",
        value: "1132468015800",
    },
]);

const organizationStructuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: COMPANY_SHORT_NAME,
    legalName: COMPANY_FULL_NAME,
    url: PUBLIC_SITE_URL,
    email: "support@svetofore.ru",
    telephone: "+7-800-222-70-79",
    taxID: "2462225394",
    identifier: [
        {
            "@type": "PropertyValue",
            name: "ОГРН",
            value: "1132468015800",
        },
        {
            "@type": "PropertyValue",
            name: "ОКВЭД",
            value: "62.01",
        },
        {
            "@type": "PropertyValue",
            name: "Вид деятельности в области ИТ",
            value: "1.01",
        },
    ],
    address: [
        {
            "@type": "PostalAddress",
            name: "Фактический адрес",
            postalCode: "660020",
            addressRegion: "Красноярский край",
            addressLocality: "Красноярск",
            streetAddress: "ул. Взлетная, д. 59",
            addressCountry: "RU",
        },
        {
            "@type": "PostalAddress",
            name: "Юридический адрес",
            postalCode: "660031",
            addressRegion: "Красноярский край",
            addressLocality: "Красноярск",
            streetAddress:
                "ул. Айвазовского, д. 57, помещ. 10",
            addressCountry: "RU",
        },
    ],
    contactPoint: {
        "@type": "ContactPoint",
        contactType: "technical support",
        email: "support@svetofore.ru",
        telephone: "+7-800-222-70-79",
        availableLanguage: [
            "Russian",
            "English",
            "Chinese",
        ],
    },
};

export function ContactsPage({t}) {
    return (
        <>
            <PageSeo
                title={t(
                    "main.contactsPage.seoTitle"
                )}
                description={t(
                    "main.contactsPage.seoDescription"
                )}
                canonicalUrl={`${PUBLIC_SITE_URL}/contacts`}
                structuredData={
                    organizationStructuredData
                }
            />

            <main className="contacts-page">
                <div className="container public-site-shell">
                    <section
                        className="contacts-page__hero"
                        aria-labelledby="contacts-page-title"
                    >
                        <div className="contacts-page__hero-heading">
                            <span className="contacts-page__eyebrow">
                                {t("main.contactsPage.eyebrow")}
                            </span>

                            <h1 id="contacts-page-title">
                                {t("main.contactsPage.title")}
                            </h1>
                        </div>
                    </section>

                    <div className="contacts-page__dashboard">
                        <div className="contacts-page__information">
                            <section
                                className="contacts-page__identity"
                                aria-labelledby="company-identity-title"
                            >
                                <span>
                                    {t(
                                        "main.contactsPage.requisites.eyebrow"
                                    )}
                                </span>

                                <h2 id="company-identity-title">
                                    {COMPANY_FULL_NAME}
                                </h2>

                                <p>{COMPANY_SHORT_NAME}</p>
                            </section>

                            <section
                                className="contacts-page__card contacts-page__requisites-card"
                                aria-labelledby="company-requisites-title"
                            >
                                <h2 id="company-requisites-title">
                                    {t(
                                        "main.contactsPage.requisites.title"
                                    )}
                                </h2>

                                <dl className="contacts-page__requisites">
                                    {requisites.map((item) => (
                                        <div key={item.labelKey}>
                                            <dt>
                                                {t(item.labelKey)}
                                            </dt>

                                            <dd>{item.value}</dd>
                                        </div>
                                    ))}
                                </dl>
                            </section>

                            <section
                                className="contacts-page__support"
                                aria-labelledby="company-support-title"
                            >
                                <span>
                                    {t(
                                        "main.contactsPage.support.eyebrow"
                                    )}
                                </span>

                                <h2 id="company-support-title">
                                    {t(
                                        "main.contactsPage.support.title"
                                    )}
                                </h2>

                                <p>
                                    {t(
                                        "main.contactsPage.support.intro"
                                    )}
                                </p>

                                <div className="contacts-page__support-links">
                                    <a href="mailto:support@svetofore.ru">
                                        support@svetofore.ru
                                    </a>

                                    <a href="tel:88002227079">
                                        8 (800) 222-70-79
                                    </a>
                                </div>
                            </section>

                            <section
                                className="contacts-page__addresses"
                                aria-labelledby="company-addresses-title"
                            >
                                <div className="contacts-page__section-heading">
                                    <h2 id="company-addresses-title">
                                        {t(
                                            "main.contactsPage.addresses.title"
                                        )}
                                    </h2>
                                </div>

                                <div className="contacts-page__address-grid">
                                    <article>
                                        <strong>
                                            {t(
                                                "main.contactsPage.addresses.actual"
                                            )}
                                        </strong>

                                        <address>
                                            {ACTUAL_ADDRESS}
                                        </address>
                                    </article>

                                    <article>
                                        <strong>
                                            {t(
                                                "main.contactsPage.addresses.legal"
                                            )}
                                        </strong>

                                        <address>
                                            {LEGAL_ADDRESS}
                                        </address>
                                    </article>
                                </div>
                            </section>
                        </div>

                        <ContactsMapSection t={t}/>
                    </div>
                </div>
            </main>
        </>
    );
}

export default withNamespaces("translation")(
    ContactsPage
);
